// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const BudgetOut = zod.object({
  "alert_threshold_pct": zod.int(),
  "committed_usd": zod.string(),
  "hard_stop": zod.boolean(),
  "inherited_from": zod.union([zod.string(),zod.null()]),
  "limit_usd": zod.string(),
  "month": zod.string(),
  "remaining_usd": zod.string(),
  "reserved_usd": zod.string(),
  "used_pct": zod.number()
});

export type BudgetOut = zod.input<typeof BudgetOut>;
export type BudgetOutOutput = zod.output<typeof BudgetOut>;
